import { FC, useEffect } from 'react';
import { Box, Button, Container, Grow, Stack, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { useMobile } from '../../contexts/mobile.context.tsx';
import { trackEvent } from '../../utils/analytics.ts';
import { Paths } from '../../constants/paths.ts';
import { useNavigate } from 'react-router-dom';

export const NotificationPage: FC = () => {
  const { sendMessage, notificationPermission } = useMobile();
  const navigate = useNavigate();
  const isDenied = notificationPermission === 'denied';

  useEffect(() => {
    if (window.sessionStorage.getItem('notifications_prompt_dismissed')) {
      navigate(Paths.HOME);
    } else {
      sendMessage('NOTIFICATIONS', 'RequestPermissions');
    }
  }, []);

  return (
    <Grow in>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          pb: 10
        }}
      >
        <Container
          sx={{
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Stack gap={3}>
            <Typography variant="h3" paragraph>
              Notifications
            </Typography>
            <Box>
              <FontAwesomeIcon icon={faBell} size="10x" color="#FFD43B" />
            </Box>
            <Typography sx={{ color: 'text.secondary' }}>
              The ABLE App would like to send you notifications. These notification will remind you of planned activities and other important information.
            </Typography>
            {notificationPermission === 'denied' && (
              <Typography sx={{ color: 'warning.main' }}>Notifications are currently disabled for this app. To enable them, open your device settings.</Typography>
            )}
            <Box display="flex" justifyContent="center">
              <Stack gap={3} width="100%" maxWidth="sm">
                <Button
                  size="large"
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    if (isDenied) {
                      sendMessage('NOTIFICATIONS', 'OpenSettings');
                      trackEvent('notifications_enable_open_settings');
                    } else {
                      sendMessage('NOTIFICATIONS', 'RequestPermissions');
                      trackEvent('notifications_enable_request');
                    }
                  }}
                >
                  {isDenied ? 'Open Settings' : 'Enable Notifications'}
                </Button>
                <Button
                  size="large"
                  fullWidth
                  variant="outlined"
                  onClick={() => {
                    trackEvent('notifications_enable_skip');
                    window.sessionStorage.setItem('notifications_prompt_dismissed', '1');
                    navigate(Paths.HOME);
                  }}
                >
                  I'll do it later
                </Button>
              </Stack>
            </Box>
          </Stack>
        </Container>
      </Box>
    </Grow>
  );
};
